module.exports = __webpack_public_path__ + "static/crema_sloik@0,75x-dc04fc18b47551cc068d568331ab7cc7.png";